<template>
  <v-app>
    <v-content>
      <v-container>
        <v-layout align-center justify-center>
          <material-card>
            <v-layout px-3 slot="header">
              <v-flex my-4 pl-4 title align-center justify-center>Regulaminy do zaakceptowania</v-flex>

              <v-spacer />
            </v-layout>

            <v-card-text>
              <v-data-table
                v-model="$schema.selectedTerms.$value"
                select-all
                hide-actions
                item-key="id"
                :headers="headers"
                :items="list"
              >
                <template v-slot:items="props">
                  <td>
                    <v-checkbox v-model="props.selected" primary hide-details />
                  </td>

                  <td>{{ props.item.order }}</td>

                  <td>
                    <a @click="showModal(props.item.id)">{{ props.item.name }}</a>
                  </td>

                  <td>{{ props.item.start }}</td>

                  <td class="text-xs-right">
                    <a download :href="config.mediaURL + '/' + props.item.mediaId">
                      <v-btn icon flat>
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </a>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>

            <v-card-actions>
              <v-flex class="text-xs-right">
                <v-btn class="primary" @click="accept">Akceptuj</v-btn>
              </v-flex>
            </v-card-actions>
          </material-card>
        </v-layout>

        <modal v-if="show" :show="show" :id="idToShow" @close="hideModal" />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { isPartner, SessionStorage } from '@witkac/kartamiejska-shared';
import { schemaMixin } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import schema from '@/schemas/termsCurrent.schema';
import { config } from '@/utils/config';
import modal from '@/views/terms/Details.modal';

// @vuese
// Wyświetlanie listy regulaminów do zaakceptowania
// @group Terms
export default {
  mixins: [schemaMixin],
  data() {
    return {
      headers: [
        {
          text: 'Kolejność',
          value: 'order'
        },
        {
          text: 'Nazwa',
          value: 'name'
        },
        {
          text: 'Data rozpoczęcia',
          value: 'start',
          sortable: true
        },
        {
          text: '',
          value: 'mediaId',
          sortable: false
        }
      ],

      config,
      idToShow: undefined,
      show: false,
      model: {}
    };
  },
  schema,
  methods: {
    // @vuese
    // Akceptuje wybrane regulaminy
    accept() {
      if (!this.$schema.$validateAll().length) {
        const profileId = parseInt(localStorage.getItem(SessionStorage.PROFILE_ID));
        this.$schema.selectedTerms.$model.forEach(terms => {
          this.$store
            .dispatch('consents/add', {
              input: { accepted: true, profileId, termsId: terms.id }
            })
            .catch(() => this.$store.dispatch('notifyError', { title: 'Nie udało się dodać zgody' }));
        });
        const target = isPartner() ? 'placeSelect' : 'profile';
        this.$router.push({ name: target });
      } else {
        this.$store.dispatch('notifyError', { title: 'Nie zaakceptowano wszystkich regulaminów' });
      }
    },
    // @vuese
    // Chowa modal
    hideModal() {
      this.idToShow = undefined;
      this.show = false;
    },
    // @vuese
    // Pokazuje modal
    showModal(id) {
      this.idToShow = id;
      this.show = true;
    }
  },
  computed: mapState({
    list(state) {
      return filterAcceptedTerms(state.terms.list, state.consents.list);
    }
  }),
  beforeCreate() {
    this.$options.external = {
      requiredLength: filterAcceptedTerms(this.$store.state.terms.list, this.$store.state.consents.list).length
    };
  },

  components: {
    MaterialCard,
    modal
  }
};

function filterAcceptedTerms(termsList, consents) {
  return termsList.filter(terms => !consents.find(consent => consent.accepted && consent.terms.id === terms.id));
}
</script>
